import FitOption from '@components/ui/FitOption'
import styles from './styles.module.scss'
import { ChildFilterValue } from '../../types'

type SquareOptionsProps = {
  values: ChildFilterValue[]
  onSelect: (option: string) => void
}

function SquareOptions({ onSelect, values }: SquareOptionsProps) {
  return (
    <div className={styles.SquareOptions}>
      {values.map(option => (
        <FitOption
          key={option.value}
          selected={option.selected}
          label={option.title}
          optionValue={option.value}
          active={option.active}
          onSelect={onSelect}
        />
      ))}
    </div>
  )
}

export default SquareOptions
